import { PredefinedJurisdiction } from '@/modules/predefined/enums/PredefinedJurisdiction';
import OntarioProbateTaxCalculator from '@/modules/tax/components/calculator/jurisdiction/ontario/OntarioProbateTaxCalculator.vue';
import { Component } from 'vue';
import { CalculatorType } from '@/modules/tax/constants/CalculatorType';
import CaliforniaProbateCalculator from '@/modules/tax/components/calculator/jurisdiction/california/CaliforniaProbateCalculator.vue';
import CaliforniaBondCalculator from '@/modules/tax/components/calculator/jurisdiction/california/CaliforniaBondCalculator.vue';
import BritishColumbiaProbateCalculator from '@/modules/tax/components/calculator/jurisdiction/britishcolumbia/BritishColumbiaProbateCalculator.vue';

export default class ProbateCalculatorFactory {
  static build(
    jurisdiction: PredefinedJurisdiction,
    type: string = CalculatorType.PROBATE
  ): Component {
    switch (jurisdiction.id) {
      case PredefinedJurisdiction.CALIFORNIA.id:
        return this.getCaliforniaCalculator(type);
      case PredefinedJurisdiction.BRITISH_COLUMBIA.id:
        return BritishColumbiaProbateCalculator;
      case PredefinedJurisdiction.ONTARIO.id:
      default:
        return OntarioProbateTaxCalculator;
    }
  }

  static getCaliforniaCalculator(type: string): Component {
    switch (type) {
      case CalculatorType.BOND:
        return CaliforniaBondCalculator;
      default:
        return CaliforniaProbateCalculator;
    }
  }
}
